import type { CancellationReason } from '../types/membership'

export interface CancellationReasonOption {
  id: CancellationReason
  label: string
}

export const cancellationReasons: CancellationReasonOption[] = [
  { id: 'not_enough_clients', label: 'I’m not getting enough client opportunities yet' },
  { id: 'too_expensive', label: 'The membership is too expensive right now' },
  { id: 'not_using_enough', label: 'I’m not using Fem Entity enough' },
  { id: 'taking_a_break', label: 'I’m taking a break from practice' },
  { id: 'changing_practice_management', label: 'I’m changing how I manage my practice' },
  { id: 'technical_issue', label: 'I had a technical issue' },
  { id: 'other', label: 'Other' },
]

export const supportEmail = 'hello@fementity.ca'
